// extracted by mini-css-extract-plugin
export var aboveInput = "_m9-0";
export var actionButton = "_m9-5";
export var actionButtonContainer = "_m9-1";
export var actionIcon = "_m9-6";
export var aiInfoContainer = "_m9-2";
export var attachmentWrapper = "_m9-7";
export var bold = "_m9-3";
export var checkIcon = "_m9-8";
export var clickingRecipientBar = "_m9-11";
export var commentThreadSwitch = "_m9-a";
export var draftImage = "_m9-b";
export var draftImageContainer = "_m9-c";
export var draftImages = "_m9-e";
export var editButton = "_m9-g";
export var editor = "_m9-f";
export var editorContainer = "_m9-y";
export var editorErrorTooltipWrapper = "_m9-9";
export var headerDivider = "_m9-h";
export var icon = "_m9-i";
export var info = "_m9-j";
export var internal = "_m9-n";
export var internalDivider = "_m9-k";
export var internalMessage = "_m9-l";
export var messageInputCard = "_m9-m";
export var messageInputForm = "_m9-o";
export var messageInputFormInternal = "_m9-p";
export var options = "_m9-q";
export var publicMessageCustomer = "_m9-s";
export var publicMessageMerchant = "_m9-r";
export var removeImageButton = "_m9-d";
export var replyButtons = "_m9-t";
export var showSignatureButton = "_m9-u";
export var spinner = "_m9-v";
export var verticalButtonDivider = "_m9-4";
export var visibilitySelector = "_m9-w";
export var warning = "_m9-x";
export var wrappingText = "_m9-z";
export var writingInternalNoteTopBorder = "_m9-10";